"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactMobileStoreButton = _interopRequireDefault(require("react-mobile-store-button"));

var _buseaVert = _interopRequireDefault(require("../../assets/busea-vert.svg"));

var _Button = _interopRequireDefault(require("../01_atoms/Button"));

var _Bottom = _interopRequireDefault(require("../01_atoms/Bottom"));

var _Page = _interopRequireDefault(require("../01_atoms/Page"));

var _PopupScreen = _interopRequireDefault(require("../02_molecules/PopupScreen"));

var _TitledContainer = _interopRequireDefault(require("../01_atoms/TitledContainer"));

var _ResponsiveCentralPaneWrapper = _interopRequireDefault(require("../02_molecules/ResponsiveCentralPaneWrapper"));

var _BoardingPass = _interopRequireDefault(require("../03_organisms/BoardingPass"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var TicketBoardingPassPageUI = function TicketBoardingPassPageUI(_ref) {
  var ticket = _ref.ticket,
      qrCodeData = _ref.qrCodeData,
      onBack = _ref.onBack,
      passengerIndex = _ref.passengerIndex,
      translatorForNamespace = _ref.translatorForNamespace,
      _ref$inPopup = _ref.inPopup,
      inPopup = _ref$inPopup === void 0 ? true : _ref$inPopup,
      _ref$showCarouselCont = _ref.showCarouselControls,
      showCarouselControls = _ref$showCarouselCont === void 0 ? true : _ref$showCarouselCont,
      _ref$showAppStoreButt = _ref.showAppStoreButtons,
      showAppStoreButtons = _ref$showAppStoreButt === void 0 ? false : _ref$showAppStoreButt,
      _ref$appleStoreLink = _ref.appleStoreLink,
      appleStoreLink = _ref$appleStoreLink === void 0 ? null : _ref$appleStoreLink,
      _ref$googlePlayLink = _ref.googlePlayLink,
      googlePlayLink = _ref$googlePlayLink === void 0 ? null : _ref$googlePlayLink,
      _ref$showPlatformLogo = _ref.showPlatformLogo,
      showPlatformLogo = _ref$showPlatformLogo === void 0 ? false : _ref$showPlatformLogo;
  var t = translatorForNamespace('TicketBoardingPassPageUI');
  var ContainerComponent = inPopup ? _PopupScreen["default"] : _Page["default"];
  return /*#__PURE__*/_react["default"].createElement(ContainerComponent, {
    title: t('Boarding Pass'),
    onBack: onBack
  }, /*#__PURE__*/_react["default"].createElement(_ResponsiveCentralPaneWrapper["default"], null, showPlatformLogo && /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '100%'
    }
  }, /*#__PURE__*/_react["default"].createElement("img", {
    alt: "",
    src: _buseaVert["default"],
    style: {
      width: 140,
      maxWidth: '50%',
      margin: 'auto'
    }
  })), /*#__PURE__*/_react["default"].createElement(_TitledContainer["default"], {
    title: t('Boarding pass'),
    rightButtonText: onBack && t('Back to ticket details'),
    onRightButtonClick: onBack && onBack
  }, /*#__PURE__*/_react["default"].createElement(_BoardingPass["default"], {
    t: t,
    ticket: ticket,
    passengerIndex: passengerIndex,
    backgroundColor: "#fff",
    qrCodeData: qrCodeData
  }), /*#__PURE__*/_react["default"].createElement(_Bottom["default"], null, showCarouselControls && ticket.ticketDetails.passengers.length > 1 && /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      display: 'flex',
      justifyContent: 'space-around',
      alignItems: 'center'
    }
  }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    disabled: passengerIndex === 0,
    to: "/tickets/".concat(ticket.id, "/boarding-pass/").concat(Math.max(0, passengerIndex - 1), "/")
  }, "\u2190"), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    disabled: passengerIndex === ticket.ticketDetails.passengers.length - 1,
    to: "/tickets/".concat(ticket.id, "/boarding-pass/").concat(passengerIndex + 1, "/")
  }, "\u2192")), showAppStoreButtons && /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
      bottom: '10px',
      width: '100%'
    }
  }, /*#__PURE__*/_react["default"].createElement(_reactMobileStoreButton["default"], {
    store: "ios",
    url: appleStoreLink,
    linkProps: {
      title: 'iOS Store Button'
    },
    height: 43,
    width: 170
  }), /*#__PURE__*/_react["default"].createElement(_reactMobileStoreButton["default"], {
    store: "android",
    url: googlePlayLink,
    linkProps: {
      title: 'Android Store Button'
    },
    height: 65,
    width: 170
  }))))));
};

var _default = TicketBoardingPassPageUI;
exports["default"] = _default;